export enum SyncSection {
	Customer = 1,
	Order,
	OrderItem,
	VoiceOption,
	PhoneBookEntry,
	Credit,
	Bill,
	BillBundle,
	Worklist
}